import { orchestrator } from 'satcheljs';
import { updateSearchText } from 'owa-agenda-events-list';
import { AgendaScenarioId } from '../constants';
import { SearchScenarioId, onSearchTextChanged } from 'owa-search';

orchestrator(onSearchTextChanged, actionMessage => {
    if (actionMessage.scenarioId === SearchScenarioId.Calendar) {
        updateSearchText(AgendaScenarioId, actionMessage.searchText);
    }
});
